import { lazy } from 'react'

export const StatisticsPage = lazy(() => import('./StatisticsPage'))
